/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsUpdate } from "../../funcs/subscriptionsUpdate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string(),
  updateSubscriptionRequestEntity:
    components.UpdateSubscriptionRequestEntity$inboundSchema,
};

export const tool$subscriptionsUpdate: ToolDefinition<typeof args> = {
  name: "subscriptions-update",
  description: `Update a subscription.

Modify subscription details like units, seats, or add-ons. Support proration and immediate billing options.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsUpdate(
      client,
      args.id,
      args.updateSubscriptionRequestEntity,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
